import { rootCap } from '../base/rootCap';
import { scale1point2 } from '../base/scale.definitions';
import { capSize } from '../typography/textBlock.css';
import { fontMetrics } from '../font/fontMetrics';
import { capSizes } from '../typography/typography.definitions';

/**
 * All available space sizes for gaps and paddings
 *
 * Each size up is 1.2 times bigger than the previous size,
 * and each size down is 1.2 times smaller than the previous size.
 *
 * Names are based on space usage in an article of text
 *
 * Names ending in CSS units are literal values.
 */
export const spaces = {
	'10 | betweenH2Sections': rootCap(scale1point2['10']),
	'9 | asideBlockMargin': rootCap(scale1point2['9']),
	'8 | betweenCards': rootCap(scale1point2['8']),
	'7 | betweenH3Sections': rootCap(scale1point2['7']),
	'6 | betweenH4Sections': rootCap(scale1point2['6']),
	'5 | betweenParagraphs': rootCap(scale1point2['5']),
	'4 | betweenListItems': rootCap(scale1point2['4']),

	...capSizes,
	'4px': '4px',
	'2px': '2px',
	'1px': '1px',
	'0px': '0',
	'1ex': `calc(${capSize} * ${(
		fontMetrics.xHeight / fontMetrics.capHeight
	).toFixed(3)})`,
} as const;

export type Space = keyof typeof spaces;
